export default "__VITE_ASSET__C8Ipc_Jb__"